import { Fragment } from '@atlaskit/editor-prosemirror/model';
import { convertMarkdownToProsemirror } from '@atlassian/ai-model-io/convert-markdown-to-prosemirror';
import { ErrorUtils } from '../utils/errors';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
export function getPMFragmentWithFallback({
  markdown,
  schema,
  source,
  fireAIAnalyticsEvent,
  idMap
}) {
  try {
    const {
      pmFragment,
      htmlConvertedToFallbackNodes,
      htmlConvertedToNodes
    } = convertMarkdownToProsemirror({
      schema,
      markdown,
      idMap,
      featureToggles: {
        // This ternary is needed because feature flags can only be called as part of
        // an expression or we get a lint error & ignoring the error prevents the
        // cleanup script from finding the flag.
        markdownPlus: getBooleanFF('platform.editor.ai-markdown-plus_9v1w7') ? true : false,
        markdownPlusMarks: getBooleanFF('platform.editor.ai-markdown-plus-marks_eitjo') ? true : false,
        markdownPlusV2: getBooleanFF('platform.editor.ai-markdown-plus-v2_j5m0c') ? true : false,
        filterEmptyCustomTags: getBooleanFF('platform.editor.ai-filter-empty-custom-tags_h6mno') ? true : false,
        markdownPlusMedia: getBooleanFF('platform.editor.ai-markdown-plus-media_svrli') ? true : false,
        markdownPlusExtensions: getBooleanFF('platform.editor.ai-markdown-plus-extension_m8eb1') ? true : false,
        markdownPlusExpands: getBooleanFF('platform.editor.ai-markdown-plus-expands_5h7qa') ? true : false,
        markdownPlusNestedExpands: getBooleanFF('platform.editor.ai-markdown-plus-nested-expands_ru5xx') ? true : false
      }
    });
    return {
      pmFragment,
      htmlConvertedToFallbackNodes,
      htmlConvertedToNodes,
      isTextFallbackUsed: false
    };
  } catch (error) {
    // When convertMarkdownToProsemirror a fragment
    // we log an analytics event to call out that markdown conversion has failed
    fireAIAnalyticsEvent({
      payload: {
        action: 'failed',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'markdownParser',
        attributes: {
          source,
          errorMessage: ErrorUtils.extractErrorMessage(error)
        },
        eventType: 'operational'
      }
    });

    // Instead of erroring, we fallback to rendering as plaintext in a single paragraph.
    const fallbackPMFragment = Fragment.from(schema.nodes.paragraph.create(null, schema.text(markdown)));
    return {
      pmFragment: fallbackPMFragment,
      htmlConvertedToFallbackNodes: 0,
      htmlConvertedToNodes: 0,
      isTextFallbackUsed: true
    };
  }
}